import { render, staticRenderFns } from "./CurriculumSUnitsClassCategories.vue?vue&type=template&id=6bd79216&scoped=true&lang=pug&"
import script from "./CurriculumSUnitsClassCategories.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSUnitsClassCategories.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSUnitsClassCategories.vue?vue&type=style&index=0&id=6bd79216&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd79216",
  null
  
)

export default component.exports